export const copyToClipboard = (
  data,
  firstName,
  lastName,
  emailAddress,
  setCopiedIndex
) => {
  const textToCopy = `${firstName} ${lastName} (${emailAddress})`;
  navigator.clipboard
    .writeText(textToCopy)
    .then(() => {
      setCopiedIndex(data.findIndex((p) => p.emailAddress === emailAddress));
      setTimeout(() => setCopiedIndex(null), 2000);
    })
    .catch((err) => console.error("Failed to copy:", err));
};

export const mergeData = (externalUsers, setMergedData, data) => {
  const emptyUsers = Array.from({ length: externalUsers }, () => ({
    id: null,
    firstName: "",
    lastName: "",
    emailAddress: "",
    bio: "",
    imageUrl: "",
    aktivniProgramResponse: [],
  }));

  setMergedData([...data, ...emptyUsers]);
};
